function HomepageSuccessIcon() {
	return (
		<svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M51.9487 13.0549C41.2088 2.31499 23.7961 2.31499 13.0585 13.0551C2.31865 23.795 2.31865 41.2075 13.0589 51.9452C23.7961 62.685 41.2088 62.685 51.9487 51.945C62.6886 41.2075 62.6886 23.795 51.9487 13.0549ZM48.708 48.7039C39.7578 57.6541 25.2475 57.6541 16.2998 48.7044C7.34965 39.7562 7.34965 25.2459 16.2996 16.2959C25.2475 7.34588 39.7578 7.34588 48.7078 16.2959C57.6578 25.246 57.6578 39.7562 48.708 48.7039Z"
				fill="#3A7DE4"
			/>
			<path
				d="M45.0642 21.6834L30.5421 36.3668L22.9431 28.6834C22.042 27.7722 20.5807 27.7722 19.6796 28.6834C18.7784 29.5946 18.7784 31.0721 19.6796 31.9833L28.9103 41.3166C29.8115 42.2278 31.2727 42.2278 32.1739 41.3166L48.3278 24.9833C49.229 24.0721 49.229 22.5946 48.3278 21.6834C47.4266 20.7722 45.9654 20.7722 45.0642 21.6834Z"
				fill="#3A7DE4"
			/>
		</svg>
	);
}

export { HomepageSuccessIcon };
